import { openDB } from 'idb'

const USE_OFFLINE_STORAGE = process.env.MODE === 'pwa'
let dbUsable = USE_OFFLINE_STORAGE
let _DB

const _version = 1
const _stores = [
  { name: 'offline_ticks', indexes: [ { name: 'internalId', unique: true } ] },
  {
    name: 'offline_tick_photos',
    indexes: [
      { name: 'internalId', unique: true },
      { name: 'tick_id', unique: false }
    ] },
  { name: 'filtered_ticks', indexes: [ { name: 'id', unique: true } ] },
  { name: 'worker_days' }
]

async function openOrCreateDatabaseAndObjectStores () {
  try {
    _DB = await openDB('TA', _version, {
      upgrade (db, oldVersion, newVersion, transaction) {
        _stores.forEach((store) => {
          if (!db.objectStoreNames.contains(store.name)) {
            const objStore = db.createObjectStore(store.name, { autoIncrement: true })
            if (store.indexes) {
              for (let i = 0; i < store.indexes.length; i++) {
                const ind = store.indexes[i]
                objStore.createIndex(ind.name, ind.name, { unique: ind.unique })
              }
            }
          }
        })
      }
    })
  } catch (e) {
    console.warn('DB IS UNUSABLE!!!')
    console.warn(e.message)
  }
  dbUsable = !!_DB
  return dbUsable
}

async function databaseReady () {
  let res
  if (dbUsable && !_DB) {
    res = await openOrCreateDatabaseAndObjectStores()
  } else {
    res = dbUsable
  }
  return res
}

export const offlineDb = {
  addRecord: async (storeName, data) => {
    if (await databaseReady()) {
      const tx = _DB.transaction(storeName, 'readwrite')
      const res = await tx.store.add(data)
      await tx.done
      return res
    } else {
      return []
    }
  },
  clearAndFillStore: async (storeName, items) => {
    if (await databaseReady()) {
      const tx = _DB.transaction(storeName, 'readwrite')
      tx.store.clear()
      items.forEach((item) => {
        tx.store.add(item)
      })
      await tx.done
    }
  },
  getAllRecords: async (storeName) => {
    if (await databaseReady()) {
      const tx = _DB.transaction(storeName, 'readonly')
      const res = tx.store.getAll()
      await tx.done
      return res
    } else {
      return []
    }
  },
  deleteRecord: async (storeName, index) => { // index: { name, value }
    if (await databaseReady()) {
      const tx = _DB.transaction(storeName, 'readwrite')
      let cursor = await tx.store.openCursor()
      while (cursor) {
        const record = cursor.value
        if (record[index.name] === index.value) cursor.delete()
        cursor = await cursor.continue()
      }
      await tx.done
      // await res !!!
    }
  },
  setNewIndexByOld: async (storeName, index) => {
    // index: { index.name, index.newValue, index.oldValue }
    if (await databaseReady()) {
      const tx = _DB.transaction(storeName, 'readwrite')
      let cursor = await tx.store.openCursor()
      while (cursor) {
        const record = { ...cursor.value }
        if (record[index.name] === index.oldValue) {
          record[index.name] = index.newValue
          cursor.update(record)
        }
        cursor = await cursor.continue()
      }
      await tx.done
    }
  },
  filterByIndex: async (storeName, index) => {
    // index: { index.name, index.filter (regExp) }
    if (await databaseReady()) {
      const tx = _DB.transaction(storeName, 'readonly')
      let cursor = await tx.store.openCursor()
      const res = []
      while (cursor) {
        const record = cursor.value
        if (String(record[index.name]).match(index.filter)) res.push(record)
        cursor = await cursor.continue()
      }
      await tx.done
      return res
    } else {
      return []
    }
  }
}
